// @flow
import type {QuoteItemType} from 'constants/flow/flowTypesCart';
import type {SimpleProductType} from 'constants/flow/flowTypesProduct';

import {emptyByDefault} from 'libs/EEC/productToEECProduct';

/**
 * Get product name
 * @param {QuoteItemType | SimpleProductType} product - product
 * @returns {string} - product name
 */
export const getName = (product: QuoteItemType | SimpleProductType): string =>
    emptyByDefault(product.window_name || product.name);
